module.exports = __webpack_public_path__ + "static/img/celoscope-34.855a16e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-34.jpg
// module id = BjIo
// module chunks = 51